import Service from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { type Client } from 'filestack-js';
import config from 'uplisting-frontend/config/environment';

export default class FileHandlerService extends Service {
  @cached @tracked client!: Client;

  public async setupClient(): Promise<void> {
    if (this.client) {
      return;
    }

    const filestack = await import('filestack-js');

    this.client = filestack.init(config.filestackKey);
  }
}

declare module '@ember/service' {
  interface Registry {
    'file-handler': FileHandlerService;
  }
}
